import { render, staticRenderFns } from "./Yuan.vue?vue&type=template&id=6a354dc1&scoped=true"
import script from "./Yuan.vue?vue&type=script&lang=js"
export * from "./Yuan.vue?vue&type=script&lang=js"
import style0 from "./Yuan.vue?vue&type=style&index=0&id=6a354dc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a354dc1",
  null
  
)

export default component.exports